import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { OrgChartNode } from "../models/org-chart-node";

@Component({
  selector: "app-tree",
  templateUrl: "./tree.component.html",
  styleUrls: ["./tree.component.scss"],
})
export class TreeComponent implements OnInit {
  @Input() orgTree: OrgChartNode[];
  @Output() editNode = new EventEmitter<OrgChartNode>();

  constructor() {}

  ngOnInit() {}

  edit(employee: OrgChartNode) {
    this.editNode.emit(employee);
  }
  collapseAll() {
    this.orgTree.forEach((t) => {
      t.collapsed = true;
      if (t.employees.length > 0) {
        this.orgTree.forEach((emp) => {
          this.modifyEmployeesVisibility(emp, true)
        });
      }
    });
  }
  expandAll() {
    this.orgTree.forEach((t) => {
      t.collapsed = false;
      if (t.employees.length > 0) {
        this.orgTree.forEach((emp) => {
          this.modifyEmployeesVisibility(emp, false)
        });
      }
    });
  }
  modifyEmployeesVisibility(node: OrgChartNode, hidden: boolean) {
    node.collapsed = hidden;
    if (node.employees.length > 0) {
      node.employees.forEach((emp) => {
          this.modifyEmployeesVisibility(emp, hidden);
        });
      }
  }
}
